import { APP_BASE_ROUTE } from '../../config'

export default {
  sort: 0,
  routers: [
    {
      path: '/',
      name: 'root',
      redirect: {
        name: APP_BASE_ROUTE
      },
      meta: {
        isHideInMenu: true,
        isCache: false,
        title: 'App'
      }
    }, {
      path: '/Login',
      name: 'login',
      meta: {
        isHideInMenu: true,
        isCache: false,
        icon: '',
        title: '登录'
      },
      component: () => import('@/views/Login')
    }
  ]
}
